import React from 'react';

// TODO
// Add color picker for type of tag
const Tag = ({ tag }) => {
  return <button className='btn btn-tag'>{tag}</button>;
};

export default Tag;
